<template>
  <div class="d-flex align-center">
    <template v-if="userData.id === 0">
      <a @click="showLogin()" class="text-muted add-to-wish-list">
        <template v-if="loading">
          <i class="fa fa-spin fa-circle-o-notch" aria-hidden="true"></i>
        </template>
        <template v-else>
          <i class="fa fa-heart-o" aria-hidden="true"></i>
        </template>
        <template v-if="showWording">{{ $translate("Snaply5::Template.singleItemWishListBtn") }}</template>
      </a>
    </template>
    <template v-else>
      <a @mouseover.once="$store.dispatch('loadComponent', 'csmodal');"  @click="addItem()" class="text-muted add-to-wish-list">
        <template v-if="loading">
          <i class="fa fa-spin fa-circle-o-notch" aria-hidden="true"></i>
        </template>
        <template v-else>
          <i class="fa fa-heart-o" aria-hidden="true"></i>
        </template>
        <template v-if="showWording">{{ $translate("Snaply5::Template.singleItemWishListBtn") }}</template>
      </a>
    </template>
  </div>
</template>

<script>

export default {
  name: "csAddToList",
  props:
  {
    variationId:
    {
      type: Number,
      default:0
    },
    quantity:
    {
      type: Number,
      default:1
    },
    showWording:
    {
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      loading:false,
    }
  },
  inject: {
    itemId: {
      default: null
    }
  },
  computed:
  {
    userData()
    {
      let user = this.$store.state.user.userData;
      let userObj =
          {
            "email":'',
            "id":0
          }
      if(user != null)
      {
        userObj.email = user.email
        userObj.id    = user.id
      }
      return userObj;
    }
  },
  methods:
  {
    currentVariation: function()
    {
      return this.$store.state.items[`${this.itemId}`];
    },
    addItem()
    {
      let variationQuantity = this.quantity;
      let variationId       = this.variationId;
      if(this.variationId === 0)
      {
        variationQuantity    = this.currentVariation().variationOrderQuantity;
        variationId          = this.currentVariation().variation.documents[0].id;
      }
      this.$store.commit('setItem', { id: variationId, quantity:variationQuantity });
      $('#addToList').modal('show');
    },
    showLogin()
    {
      this.$store.dispatch('loadComponent', 'login-modal')
      $('#login').modal("show")
    },
  }
}
</script>